import React from "react";
import PropTypes from "prop-types";

import Tooltip from "core/Tooltip";
import SrOnly from "core/SrOnly";

import { EditorFlipButton } from "./styles";

import FlipUp from "core/ReusableIcons/FlipUp";
import FlipDown from "core/ReusableIcons/FlipDown";
import FlipLeft from "core/ReusableIcons/FlipLeft";
import FlipRight from "core/ReusableIcons/FlipRight";

import { useIconEditorDispatch } from "js/contexts/IconEditorContext";

const EditorFlip = ({ axis, flipY, flipX, iconId }) => {
    const dispatch = useIconEditorDispatch();

    const flipIcon = () => {
        let actionType;

        if (axis === "x") actionType = "FLIP_X";
        if (axis === "y") actionType = "FLIP_Y";

        dispatch({
            type: actionType,
            iconId
        });
    };

    const getTooltipText = () => {
        if (axis === "y") return "Flip";
        if (axis === "x") return "Reverse";
    };

    // TODO: move to helpers.js file

    let FlipControlIcon;

    if (axis === "y") {
        if (!flipY) FlipControlIcon = FlipUp;
        if (flipY) FlipControlIcon = FlipDown;
    } else if (axis === "x") {
        if (!flipX) FlipControlIcon = FlipRight;
        if (flipX) FlipControlIcon = FlipLeft;
    }

    return (
        <Tooltip message={getTooltipText()} size="small">
            <EditorFlipButton onClick={() => flipIcon()}>
                <FlipControlIcon size="sm" />
                <SrOnly>{getTooltipText()}</SrOnly>
            </EditorFlipButton>
        </Tooltip>
    );
};

EditorFlip.propTypes = {
    axis: PropTypes.oneOf(["y", "x"]).isRequired,
    flipY: PropTypes.bool,
    flipX: PropTypes.bool,
    iconId: PropTypes.string
};

export default React.memo(EditorFlip);
